import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-insurance-details-form',
  templateUrl: './insurance-details-form.component.html',
  styleUrls: ['./insurance-details-form.component.css']
})
export class InsuranceDetailsFormComponent implements OnInit {

  title="Add Insurance Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/insurance-details/insurance-details-form/insurance-details-form.component.ts